import { SERVER_API } from 'RootDir/common/constants';

import { generateCrudEndpoints } from './helpers';

const authUrl = `${SERVER_API}/auth`;
export const AUTHORIZATION = {
  LOGIN: `${authUrl}/login`,
  REFRESH_TOKEN: `${authUrl}/refresh-token`,
  LOGOUT: `${authUrl}/logout`,
  // PING: `${authUrl}/ping`,
  // FORGOT_PASSWORD: `${authUrl}/forgot-password`,
  RESET_PASSWORD(id: number) {
    return `${authUrl}/${id}/reset-password`;
  },
};

const profileUrl = `${SERVER_API}/profile`;

export const PROFILE = {
  GET: {
    method: 'GET',
    url: profileUrl,
  } as IEndpointData,
  SAVE: {
    method: 'PUT',
    url: profileUrl,
  } as IEndpointData,
};

export const FILE_GET = (id: string): IEndpointData => ({
  method: 'GET',
  url: `${SERVER_API}/file/${id}`,
});

export const FILE_UPLOAD = {
  method: 'POST',
  url: `${SERVER_API}/file/upload`,
};

const statisticsUrl = `${SERVER_API}/statistics`;

export const STATISTICS = {
  BI: {
    method: 'GET',
    url: `${statisticsUrl}/bi`,
  } as IEndpointData,
  HUNTING_TICKETS: {
    method: 'GET',
    url: `${statisticsUrl}/hunting-tickets`,
  } as IEndpointData,
  HUNTING_APPLICATIONS: {
    method: 'GET',
    url: `${statisticsUrl}/hunting-applications`,
  } as IEndpointData,
  USERS_STATISTICS: {
    method: 'GET',
    url: `${statisticsUrl}/users`,
  } as IEndpointData,
};

/* API СПРАВОЧНИКОВ */
const catalogsUrl = `${SERVER_API}/catalogs`;

export const CATALOGS_DEPARTMENT = generateCrudEndpoints(`${catalogsUrl}/departments`);

export const CATALOGS_TERRITORY = generateCrudEndpoints(`${catalogsUrl}/territories`);

export const CATALOGS_ANIMALS = generateCrudEndpoints(`${catalogsUrl}/animals`);

export const CATALOGS_SEASONS = generateCrudEndpoints(`${catalogsUrl}/seasons`);

export const CATALOGS_SEASON_TYPES = generateCrudEndpoints(`${catalogsUrl}/season-types`);

export const CATALOGS_ZONES = generateCrudEndpoints(`${catalogsUrl}/zones`);

const catalogOrdersUrl = `${SERVER_API}/orders`;

export const CATALOGS_STATUSES = {
  LIST: {
    method: 'GET',
    url: `${catalogOrdersUrl}/hunting-tickets/status_application`,
  } as IEndpointData,
};

export const CATALOGS_SOURCE = {
  LIST: {
    method: 'GET',
    url: `${catalogsUrl}/hunting-tickets/source_application`,
  } as IEndpointData,
};
export const GISGMP_SETTINGS = {
  LIST: {
    method: 'GET',
    url: `${catalogsUrl}/gis-gmp/settings`,
  } as IEndpointData,
};

export const CATALOGS_REGIONS = {
  LIST: {
    method: 'GET',
    url: `${catalogsUrl}/regions`,
  } as IEndpointData,
};

export const CATALOGS_ANNULMENT_REASONS = {
  LIST: {
    method: 'GET',
    url: `${catalogsUrl}/annulment-reasons`,
  } as IEndpointData,
};

const catalogCountriesUrl = `${catalogsUrl}/countries`;
export const CATALOGS_COUNTRIES = {
  LIST: {
    method: 'GET',
    url: `${catalogCountriesUrl}`,
  } as IEndpointData,
  STORE: {
    method: 'POST',
    url: `${catalogCountriesUrl}/`,
  } as IEndpointData,
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${catalogCountriesUrl}/${id.toString()}`,
    };
  },
  DELETE(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${catalogCountriesUrl}/${id.toString()}`,
    };
  },
  RESTORE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${catalogCountriesUrl}/restore/${id.toString()}`,
    };
  },
};

/* API АДМИНИСТРИРОВАНИЯ */
const administrationUrl = `${SERVER_API}/administration`;
export const ADMINISTRATION_RECEPTION_RULE = generateCrudEndpoints(
  `${administrationUrl}/reception-rules`
);
export const ADMINISTRATION_PRODUCTION_CALENDAR = generateCrudEndpoints(
  `${administrationUrl}/production-calendar`
);

const administrationUserUrl = `${administrationUrl}/user`;
export const ADMINISTRATION_SYSTEM_USER = {
  LIST: {
    method: 'GET',
    url: `${administrationUserUrl}`,
  } as IEndpointData,
  STORE: {
    method: 'POST',
    url: `${administrationUserUrl}`,
  } as IEndpointData,
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${administrationUserUrl}/${id.toString()}`,
    };
  },
  DELETE(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${administrationUserUrl}/${id.toString()}`,
    };
  },
  RESTORE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${administrationUserUrl}/restore/${id.toString()}`,
    };
  },
};

const administrationRoleUrl = `${administrationUrl}/role`;
export const ADMINISTRATION_ROLES = {
  LIST: {
    method: 'GET',
    url: `${administrationRoleUrl}`,
  } as IEndpointData,
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${administrationRoleUrl}/${id.toString()}`,
    };
  },
};

export const SEASONS_CONFIG = generateCrudEndpoints(`${administrationUrl}/season-configs`);

/* Подписки на события ГИС ГМП */
const gisGmpSubscriptionsUrl = `${administrationUrl}/gis-gmp/subscriptions`;
export const ADMINISTRATION_GIS_GMP_SUBSCRIPTIONS = {
  LIST: {
    method: 'GET',
    url: gisGmpSubscriptionsUrl,
  } as IEndpointData,
  CATALOG: {
    method: 'GET',
    url: `${gisGmpSubscriptionsUrl}/catalog`,
  } as IEndpointData,
  REFRESH_CATALOG: {
    method: 'POST',
    url: `${gisGmpSubscriptionsUrl}/catalog/refresh`,
  } as IEndpointData,
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${gisGmpSubscriptionsUrl}/${id}`,
    };
  },
  SUBSCRIBE: {
    method: 'POST',
    url: gisGmpSubscriptionsUrl,
  } as IEndpointData,
  UNSUBSCRIBE(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${gisGmpSubscriptionsUrl}/${id}`,
    };
  },
  HISTORY(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${gisGmpSubscriptionsUrl}/${id}/history`,
    };
  },
};

// const userProfileUrl = `${administrationUrl}/user`;
// export const PROFILE = {
//   UPDATE: {
//     method: 'PUT',
//     url: userProfileUrl,
//   } as IEndpointData,
// };

/* УЧЁТ ФИЗИЧЕСКИХ ЛИЦ */
const individualPersonUrl = `${SERVER_API}/administration/individual-persons`;

export const INDIVIDUAL_PERSON = {
  LIST: {
    method: 'GET',
    url: `${individualPersonUrl}`,
  } as IEndpointData,
  STORE: {
    method: 'POST',
    url: `${individualPersonUrl}`,
  } as IEndpointData,
  SHOW(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${individualPersonUrl}/${id.toString()}`,
    };
  },
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${individualPersonUrl}/${id.toString()}`,
    };
  },
  DELETE(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${individualPersonUrl}/${id.toString()}`,
    };
  },
  RESTORE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${individualPersonUrl}/restore/${id.toString()}`,
    };
  },
  UPDATE_ADDRESSES(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${individualPersonUrl}/${id.toString()}/addresses`,
    };
  },
  DEEP_INSPECTION(id: number, side: string): IEndpointData {
    return {
      method: 'GET',
      url: `${individualPersonUrl}/${id.toString()}/deep/${side}`,
    };
  },
  GET_PASSPORT_ISSUERS: {
    method: 'GET',
    url: `${individualPersonUrl}/passport-issuer`,
  } as IEndpointData,
};

/* УЧЁТ Заявлений на выдачу охотбилетов */
const huntingTicketOrdersUrl = `${SERVER_API}/orders/hunting-ticket-applications`;

export const HUNTING_TICKET_ORDERS = {
  LIST: {
    method: 'GET',
    url: `${huntingTicketOrdersUrl}`,
  } as IEndpointData,
  STORE: {
    method: 'POST',
    url: `${huntingTicketOrdersUrl}`,
  } as IEndpointData,
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${huntingTicketOrdersUrl}/${id.toString()}`,
    };
  },
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${huntingTicketOrdersUrl}/${id.toString()}`,
    };
  },
  TAKE_TO_WORK(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingTicketOrdersUrl}/${id.toString()}/take`,
    };
  },
  REJECT(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingTicketOrdersUrl}/${id.toString()}/reject`,
    };
  },
  SUBMIT(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingTicketOrdersUrl}/${id.toString()}/submit`,
    };
  },
  GET_MESSAGES(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${huntingTicketOrdersUrl}/${id.toString()}/messages`,
    };
  },
  SEND_MESSAGE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingTicketOrdersUrl}/${id.toString()}/send-message`,
    };
  },
};

const huntingLicenseOrdersUrl = `${SERVER_API}/orders/hunting-licenses`;

export const HUNTING_LICENSE_ORDERS = {
  LIST: {
    method: 'GET',
    url: `${huntingLicenseOrdersUrl}`,
  } as IEndpointData,
  STORE: {
    method: 'POST',
    url: `${huntingLicenseOrdersUrl}`,
  } as IEndpointData,
  APPROVAL_LIST: {
    method: 'GET',
    url: `${huntingLicenseOrdersUrl}/approval`,
  } as IEndpointData,
  APPROVAL_CHANGE_ACCEPT(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${huntingLicenseOrdersUrl}/approval/${id}/change-accepted`,
    };
  },
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}`,
    };
  },
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}`,
    };
  },
  TAKE_TO_WORK(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/take`,
    };
  },
  SEND_PAYMENT_DOCS(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/send-payment-docs`,
    };
  },
  PRINT_PERMISSION(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/print-form`,
    };
  },
  PRINT_ISSUE(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/print-issue`,
    };
  },
  CHANGE_STATUS(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/change-status`,
    };
  },
  REJECT(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/reject`,
    };
  },
  ISSUE_LICENSE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/issue-license`,
    };
  },
  SUBMIT(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/submit`,
    };
  },
  GET_MESSAGES(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/messages`,
    };
  },
  SEND_MESSAGE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/send-message`,
    };
  },
  SET_SEASON(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/set-season`,
    };
  },
  SEND_CHARGE: (id: number) =>
    ({
      method: 'POST',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/send-charge`,
    } as IEndpointData),
  CANCEL_CHARGE: (id: number, chargeId: number) =>
    ({
      method: 'POST',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/cancel-charge/${chargeId.toString()}`,
    } as IEndpointData),
  CHECK_CHARGE: (id: number, chargeId: number) =>
    ({
      method: 'POST',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/check-charge/${chargeId.toString()}`,
    } as IEndpointData),
  GET_CHARGE: (id: number, chargeId: number) =>
    ({
      method: 'GET',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/get-charge/${chargeId.toString()}`,
    } as IEndpointData),
  SUBSCRIPTION_PAYMENTS: (id: number) =>
    ({
      method: 'GET',
      url: `${huntingLicenseOrdersUrl}/${id.toString()}/subscription-payments`,
    } as IEndpointData),
};

const huntingTicketAnnulmentOrdersUrl = `${SERVER_API}/orders/hunting-tickets-annulment`;

export const HUNTING_TICKET_ANNULMENT_ORDERS = {
  LIST: {
    method: 'GET',
    url: `${huntingTicketAnnulmentOrdersUrl}`,
  } as IEndpointData,
  STORE: {
    method: 'POST',
    url: `${huntingTicketAnnulmentOrdersUrl}`,
  } as IEndpointData,
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${huntingTicketAnnulmentOrdersUrl}/${id.toString()}`,
    };
  },
  REJECT(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingTicketAnnulmentOrdersUrl}/${id.toString()}/reject`,
    };
  },
  SUBMIT(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingTicketAnnulmentOrdersUrl}/${id.toString()}/submit`,
    };
  },
};

const huntingTicketrsUrl = `${SERVER_API}/orders/hunting-tickets`;

export const HUNTING_TICKETS = {
  LIST: {
    method: 'GET',
    url: `${huntingTicketrsUrl}`,
  } as IEndpointData,
  STORE: {
    method: 'POST',
    url: `${huntingTicketrsUrl}`,
  } as IEndpointData,
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${huntingTicketrsUrl}/${id.toString()}`,
    };
  },
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${huntingTicketrsUrl}/${id.toString()}`,
    };
  },
  SCHEDULE: {
    method: 'GET',
    url: `${huntingTicketrsUrl}/visits/schedule`,
  } as IEndpointData,
  ANNULMENT(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingTicketrsUrl}/${id.toString()}/annulment`,
    };
  },
  RESTORE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${huntingTicketrsUrl}/${id.toString()}/restore`,
    };
  },
  ISSUE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${huntingTicketrsUrl}/${id.toString()}/issue`,
    };
  },
};

const reportsUrl = `${SERVER_API}/reports`;

export const PRINTED_FORM = {
  PRINT_BLANK(type: string): IEndpointData {
    return {
      method: 'POST',
      url: `${reportsUrl}/printed-form/blank?type=${type}`,
    };
  },
};

export const REPORTS = {
  FORM7_1: {
    method: 'GET',
    url: `${reportsUrl}/form71`,
  } as IEndpointData,
  FORM7_1_2: {
    method: 'GET',
    url: `${reportsUrl}/form71_2`,
  } as IEndpointData,
  TASKS: {
    method: 'GET',
    url: `${reportsUrl}/tasks`,
  } as IEndpointData,
  TAX: {
    method: 'GET',
    url: `${reportsUrl}/tax`,
  } as IEndpointData,
};

const interdepartmentUrl = `${SERVER_API}/orders/interdepartments`;

export const INTERDEPARTMENT = {
  MVD_GET: {
    method: 'GET',
    url: `${interdepartmentUrl}/mvd/conviction`,
  } as IEndpointData,
  MVD_ASK: {
    method: 'POST',
    url: `${interdepartmentUrl}/mvd/conviction`,
  } as IEndpointData,
  MVD_DECIDE(convictionId: number): IEndpointData {
    return {
      method: 'POST',
      url: `${interdepartmentUrl}/mvd/conviction/${convictionId}/decide`,
    };
  },
  MVD_DECIDE_MANUAL(): IEndpointData {
    return {
      method: 'POST',
      url: `${interdepartmentUrl}/mvd/conviction/decide/manual`,
    };
  },
  FMS_GET: {
    method: 'GET',
    url: `${interdepartmentUrl}/mvd/passport-check`,
  } as IEndpointData,
  FMS_ASK: {
    method: 'POST',
    url: `${interdepartmentUrl}/mvd/passport-check`,
  } as IEndpointData,
  FMS_DECIDE_MANUAL(): IEndpointData {
    return {
      method: 'POST',
      url: `${interdepartmentUrl}/mvd/passport-check/decide/manual`,
    };
  },
};

const staticUrl = `${SERVER_API}/static`;

export const STATIC = {
  GET_FILE(filename: string): IEndpointData {
    return {
      method: 'GET',
      url: `${staticUrl}/docs/${filename}`,
    };
  },
};

const resourceQueueUrl = `${SERVER_API}/resource-queue`;

export const RESOURCE_QUEUE_CATALOGS = {
  TERRITORIES: {
    method: 'GET',
    url: `${resourceQueueUrl}/catalogs/territories`,
  } as IEndpointData,
  RESOURCES: {
    method: 'GET',
    url: `${resourceQueueUrl}/catalogs/resources`,
  } as IEndpointData,
  RESOURCE_PERIODS: {
    method: 'GET',
    url: `${resourceQueueUrl}/catalogs/resource-periods`,
  } as IEndpointData,
  UPDATE_RESOURCE: (id) =>
    ({
      method: 'PUT',
      url: `${resourceQueueUrl}/catalogs/resources/${id}`,
    } as IEndpointData),
};

export const RESOURCE_QUEUE_QUEUE = {
  ...generateCrudEndpoints(`${resourceQueueUrl}/queue`),
  CHANGE_STATUS(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${resourceQueueUrl}/queue/change-status/${id}`,
    };
  },
};

export const RESOURCE_QUEUE_APPLICATIONS = {
  ...generateCrudEndpoints(`${resourceQueueUrl}/applications`),
  CHANGE_STATUS(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${resourceQueueUrl}/applications/change-status/${id}`,
    };
  },
  GET_NEW_COUNT: {
    method: 'GET',
    url: `${resourceQueueUrl}/applications/new`,
  } as IEndpointData,
  STORE: undefined,
  UPDATE: undefined,
  DELETE: undefined,
  LIST_BRIEF: undefined,
};

export const RESOURCE_REJECT_APPLICATIONS = {
  ...generateCrudEndpoints(`${resourceQueueUrl}/reject-applications`),
  CHANGE_STATUS(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${resourceQueueUrl}/reject-applications/change-status/${id}`,
    };
  },
  STORE: undefined,
  UPDATE: undefined,
  DELETE: undefined,
  LIST_BRIEF: undefined,
};
